import { ColumnProps } from 'antd/lib/table'
import FilterDropdownSelect from '.'
import FilterIcon from '@/pages/program/temporary/widgets/filter-icon'
import { Tooltip } from 'antd'
import { t } from '@/i18n'

interface FilterOption {
  value: string
  label: string
}

interface CreateFilterColumnOptions {
  title: string
  dataIndex: string
  key: string
  width?: number
  options: FilterOption[]
  placeholder?: string
  allowClear?: boolean
  mode?: 'multiple' | 'tags'
  style?: React.CSSProperties
  render?: (value: any, record: any) => React.ReactNode
}

export const createFilterColumn = ({
  title,
  dataIndex,
  key,
  width,
  options,
  placeholder = t('请选择'),
  allowClear = true,
  mode = 'multiple',
  style,
  render,
}: CreateFilterColumnOptions): ColumnProps<any> => ({
  title,
  dataIndex,
  key,
  width,
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
    <FilterDropdownSelect
      value={selectedKeys as string[]}
      onChange={setSelectedKeys}
      onConfirm={confirm}
      onClear={clearFilters}
      options={options}
      placeholder={placeholder}
      allowClear={allowClear}
      mode={mode}
      style={style}
    />
  ),
  filterIcon: (filtered: boolean) => (
    <Tooltip title={t('筛选')} getPopupContainer={() => document.body}>
      <FilterIcon filtered={filtered} />
    </Tooltip>
  ),
  render,
})
